ACC.refinements = {
  _autoload: [
    ['bindMoreLessToggles', $('.js-facet-form').length !== 0],
    ['bindMoreStoresToggles', $('.js-facet-form').length !== 0],
    ['init', $('.js-facet-form').length !== 0],
    ['bindSearch', $('.formname').length !== 0],
    ['bindCollapse', $('.search-refine__panel-icon').length !== 0]
  ],

  coords: {},
  storeSearchData: {},

  init: function() {
    navigator.geolocation.getCurrentPosition(
      function(position) {
        ACC.refinements.coords = position.coords;
      },
      function(error) {
        console.log(
          'An error occurred... The error code and message are: ' +
            error.code +
            '/' +
            error.message
        );
      }
    );
  },

  bindCollapse: function() {
    $('.search-refine__panel-icon').on('click', function(event) {
      if (event.currentTarget.classList.contains('svg-icon_minus')) {
        event.currentTarget.classList.add('svg-icon_plus');
        event.currentTarget.classList.add('svg-icon_plus-dims');
        event.currentTarget.classList.remove('svg-icon_minus');
        event.currentTarget.classList.remove('svg-icon_minus-dims');
      } else {
        event.currentTarget.classList.remove('svg-icon_plus');
        event.currentTarget.classList.remove('svg-icon_plus-dims');
        event.currentTarget.classList.add('svg-icon_minus');
        event.currentTarget.classList.add('svg-icon_minus-dims');
      }
    });
  },
  bindSearch: function() {
    $(document).on('submit', '#user_location_form', function(e) {
      e.preventDefault();
      var q = $('.js-shop-stores-facet .js-shop-store-search-input').val();
      if (q.length > 0) {
        ACC.refinements.getInitStoreData(q);
      }
    });

    $(document).on('click', '#findStoresNearMeAjax', function(e) {
      e.preventDefault();
      ACC.refinements.getInitStoreData(
        null,
        ACC.refinements.coords.latitude,
        ACC.refinements.coords.longitude
      );
    });
  },

  getInitStoreData: function(q, latitude, longitude) {
    $('.alert').remove();
    data = {
      q: '',
      page: '0'
    };

    if (q != null) {
      data.q = q;
    }

    if (latitude != null) {
      data.latitude = latitude;
    }

    if (longitude != null) {
      data.longitude = longitude;
    }

    ACC.refinements.storeSearchData = data;
    ACC.refinements.getStoreData();
  },

  getStoreData: function() {
    url = $('.js-facet-form').data('url');
    $.ajax({
      url: url,
      data: ACC.refinements.storeSearchData,
      type: 'get',
      dataType: 'text',
      success: function(response) {
        window.location.reload();
      }
    });
  },

  bindMoreLessToggles: function() {
    var initialString = $("input[name='q']").val();
    var query;
    var indexOfFirst = initialString.indexOf(':');
    var indexofSecond = initialString.indexOf(':', indexOfFirst + 1);

    query =
      indexofSecond < 0
        ? initialString
        : initialString.substr(0, indexofSecond);

    $(document).on(
      'click',
      '.js-shop-stores-facet .js-facet-change-link',
      function(e) {
        e.preventDefault();
        $('.js-shop-stores-facet .js-facet-container').hide();
        $('.js-shop-stores-facet .js-facet-form').show();
      }
    );

    /*$(document).on("change", ".js-product-facet .js-facet-checkbox", function() {*/
    $(document).on('change', '.search-refine-custom-checkbox', function() {
      $('#loadingGif').show();
      if (!$(this).is('[name]')) {
        //Referring to more-facet checkboxes
        query = query + ':' + $(this).attr('data-query');
      } else {
        query = query + $(this).attr('data-query');
      }
      $("input[name='q']").attr('value', query);
      if ($('.search-refine').hasClass('hidden-xs')) {
        $('.search-refine__form').submit();
      }
    });

    $(document).on('click', '.search-refine__more-items', function(e) {
      e.preventDefault();
      $(this)
        .parent('div')
        .find('.search-refine__more-content')
        .removeClass('hide')
        .show();

      $(this)
        .parent('div')
        .find('.search-refine__less-items')
        .show();
      $(this)
        .parent('div')
        .find('.search-refine__more-items')
        .hide();
    });

    $(document).on('click', '.search-refine__less-items', function(e) {
      e.preventDefault();
      $(this)
        .parent('div')
        .find('.search-refine__more-content')
        .addClass('hide')
        .hide();

      $(this)
        .parent('div')
        .find('.search-refine__less-items')
        .hide();
      $(this)
        .parent('div')
        .find('.search-refine__more-items')
        .show();
    });

    $(document).on(
      'click',
      '#product-facet .filtersLink, .search-refine__radio',
      function() {
        $('#loadingGif').show();
      }
    );
  },

  bindMoreStoresToggles: function() {
    $(document).on(
      'click',
      '.js-shop-stores-facet .js-more-stores-facet-values',
      function(e) {
        e.preventDefault();
        $('.js-shop-stores-facet ul.js-facet-list li.hidden')
          .slice(0, 5)
          .removeClass('hidden')
          .first()
          .find('.js-facet-checkbox')
          .focus();
        if (
          $('.js-shop-stores-facet ul.js-facet-list li.hidden').length === 0
        ) {
          $('.js-shop-stores-facet .js-more-stores-facet-values').hide();
        }
      }
    );
  }
};
